<template>
  <div class="component">
    <label class="fw-bold"> {{ label }}</label>
    <div class="box">
      <div class="search">
        <custom-input
          v-model="searchText"
          placeholder="Wyszukaj"
          type="text"
        />
      </div>
      <div class="list">
        <div
          class="box-row"
          v-for="child in filteredProducts"
          :key="child.id"
          @click="child.selected = !child.selected"
        >
          <div
            class="child"
            v-if="isVisible(child.selected)"
          >
            {{ child.name }} {{ child.surname }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import CustomInput from '../common/CustomInput.vue';

export default {
  name: 'children-box.vue',
  components: { CustomInput },
  props: {
    children: Array,
    label: String,
    selected: Boolean,
  },
  setup(props) {
    function isVisible(value) {
      return value === props.selected;
    }

    const searchText = ref('');

    const filteredProducts = computed(() => {
      let filteredItems = [];
      if (props.children && searchText.value) {
        filteredItems = props.children.filter((child) => (
          (child.name && child.name.toLowerCase().includes(searchText.value.toLowerCase()))
          || (child.surname && child.surname.toLowerCase().includes(searchText.value.toLowerCase()))
        ));
      } else if (props.children) {
        filteredItems = props.children;
      }
      return filteredItems;
    });

    return {
      filteredProducts,
      isVisible,
      searchText,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';
.component {
  display: flex;
  align-items: flex-start;
  justify-content: left;
  flex-direction: column;
  width: 45%;

  .box {
    border: 1px solid $light-grey;
    border-radius: 5px;
    overflow-y: auto;
    padding: 20px;
    width: 100%;

    .list {
      height: 400px;
      overflow-y: auto;
      width: 100%;
    }

    .box-row {
      cursor: pointer !important;
      display: flex;
      flex-direction: row;
      width: 100%;

      &:hover {
        background-color: $light-grey;
      }
    }
  }
}
</style>
